// extracted by mini-css-extract-plugin
export default {"priceCalculatorBox":"style_priceCalculatorBox__oFOIP","pricePerMonth":"style_pricePerMonth__7b3jS","underText":"style_underText__p59vF"};